import React from 'react';
import './styles.scss';

const ElectionButton = ({
  src,
  onClick,
  label,
  alt = 'Button',
  className = '',
  size,
  style = {},
  bottomOffset = 0
}) => (
  <div
    className="election-button-container"
    style={Object.assign({}, bottomOffset && { marginBottom: `${bottomOffset}px` })}
  >
    <img
      className={`election-button ${className ? className : ''}`}
      style={{ width: `${size}px`, height: `${size}px`, ...style }}
      onClick={onClick}
      src={src}
      alt={alt}
    />
    <span>{label}</span>
  </div>
);

export default ElectionButton;
